export default __webpack_public_path__ + "static/media/services-bg.5c6ae6fd.jpg";